import { GET_DEFAULT_REPORT_FAIL, GET_DEFAULT_REPORT_REQUEST, GET_DEFAULT_REPORT_SUCCESS, 
  GET_SURVEY_FORM_FAIL, GET_SURVEY_FORM_REQUEST, GET_SURVEY_FORM_SUCCESS,
   GET_SURVEY_REPORT_FAIL, GET_SURVEY_REPORT_REQUEST, GET_SURVEY_REPORT_SUCCESS, 
   GET_SURVEY_RESULT_FAIL, GET_SURVEY_RESULT_REQUEST, GET_SURVEY_RESULT_SUCCESS, 
   GET_SURVEY_SECTIONS_FAIL, GET_SURVEY_SECTIONS_REQUEST, GET_SURVEY_SECTIONS_SUCCESS, 
   SUBMIT_SURVEY_FORM_FAIL, SUBMIT_SURVEY_FORM_REQUEST, SUBMIT_SURVEY_FORM_SUCCESS ,
   GET_SURVEY_DETAIL_REQUEST,GET_SURVEY_DETAIL_SUCCESS, GET_SURVEY_DETAIL_FAIL 
  } from "../constant";

const initialState = {
  surveySections: {},
  surveyFormQuestions: [],
  surveyResult: {},
  defaultReport: {},
  surveyReport: '',
  surveyDetail: {}
}

const language = localStorage.getItem('customer_language') ?? '22'

const surveyFormReducer = (state = initialState, action) => {
  switch (action.type) {
    //Get survey form
    case GET_SURVEY_FORM_REQUEST:
      return {
        ...state,
        surveyFormQuestions: []
      }
    case GET_SURVEY_FORM_SUCCESS:
      return {
        ...state,
        surveyFormQuestions: action?.payload ?? []
      }
    case GET_SURVEY_FORM_FAIL:
      return {
        ...state,
        surveyFormQuestions: []
      }

    //Get survey section
    case GET_SURVEY_SECTIONS_REQUEST:
      return {
        ...state,
        surveySections: {}
      }
    case GET_SURVEY_SECTIONS_SUCCESS:
      let data = {}
      action?.payload?.forEach((section) => {
        data[section.su_section_id] = {
          name: section.su_section_name ? JSON.parse(section.su_section_name)[language] : '',
          order: section.su_order_no ?? 0,
          desc: section.su_section_desc ? JSON.parse(section.su_section_desc)[language] : '',
          cnt : section.cnt ?? 0
        }
      })
      return {
        ...state,
        surveySections: data
      }
    case GET_SURVEY_SECTIONS_FAIL:
      return {
        ...state,
        surveySections: {}
      }

    //Submit survey
    case SUBMIT_SURVEY_FORM_REQUEST:
      return {
        ...state,
      }
    case SUBMIT_SURVEY_FORM_SUCCESS:
      return {
        ...state,
      }
    case SUBMIT_SURVEY_FORM_FAIL:
      return {
        ...state,
      }

    //Get survey result
    case GET_SURVEY_RESULT_REQUEST:
      return {
        ...state,
        surveyResult: {}
      }
    case GET_SURVEY_RESULT_SUCCESS:
      return {
        ...state,
        surveyResult: action.payload
      }
    case GET_SURVEY_RESULT_FAIL:
      return {
        ...state,
        surveyResult: {}
      }

    //Get survey report
    case GET_SURVEY_REPORT_REQUEST:
      return {
        ...state,
        surveyReport: ''
      }
    case GET_SURVEY_REPORT_SUCCESS:
      return {
        ...state,
        surveyReport: action.payload
      }
    case GET_SURVEY_REPORT_FAIL:
      return {
        ...state,
        surveyReport: ''
      }

    //Get default report
    case GET_DEFAULT_REPORT_REQUEST:
      return {
        ...state,
        defaultReport: {}
      }
    case GET_DEFAULT_REPORT_SUCCESS:
      const tmpDefaultReport = action.payload && action.payload[0]
      return {
        ...state,
        defaultReport: tmpDefaultReport ?? {}
      }
    case GET_DEFAULT_REPORT_FAIL:
      return {
        ...state,
        defaultReport: {}
      }

      case GET_SURVEY_DETAIL_REQUEST:
        return {
          ...state,
          surveyDetail: {}
        }
      case GET_SURVEY_DETAIL_SUCCESS:
        return {
          ...state,
          surveyDetail: action.payload
        }
      case GET_SURVEY_DETAIL_FAIL:
        return {
          ...state,
          surveyDetail: {}
        }  

    //Default
    default:
      return state;
  }
}

export default surveyFormReducer